import axios from "@/network";
import { WorkExperienceInterface } from "../types";

export function apiGetWorkExperiences(params: any, headers: Record<string, string> = {}) {
  const url = "/work_experiences";
  return axios.get(url, { params, headers });
}

export function apiGetWorkExperience(workExperienceId: number) {
  const url = `/work_experiences/${workExperienceId}`;
  return axios.get(url);
}

export function apiUpdateWorkExperience(
  workExperienceId: number,
  updatedWorkExperience: WorkExperienceInterface
) {
  const url = `/work_experiences/${workExperienceId}`;
  const payload = { work_experience: updatedWorkExperience };
  return axios.patch(url, payload);
}

export function apiDeleteWorkExperience(workExperienceId: number): Promise<Object> {
  const url = `/work_experiences/${workExperienceId}`;
  return axios.delete(url);
}

export function apiStoreWorkExperience(newWorkExperience: WorkExperienceInterface, userId: number) {
  const url = `/users/${userId}/work_experiences`;
  const payload = { work_experience: newWorkExperience };
  return axios.post(url, payload);
}
